import Vue from 'vue';

const CHANNEL_TOC_LOADED = 'CHANNEL_TOC_LOADED'; // if the process is completed; not guaranteed it was loaded
const CHANNEL_AUTHENTICATED = 'CHANNEL_AUTHENTICATED';
const CHANNEL_BUS_MESSAGE = 'CHANNEL_BUS_MESSAGE'; // generic channel to send messages
const CHANNEL_ENVIRONMENT_LOADED = 'CHANNEL_ENVIRONMENT_LOADED';
const CHANNEL_USER_LOADED = 'CHANNEL_USER_LOADED'; // if a user was loaded, does not mean it was a success
const CHANNEL_USER_AUTH_FAILED = 'CHANNEL_USER_AUTH_FAILED'; // if a user was loaded, does not mean it was a success
const CHANNEL_TOGGLE_SIDEBAR = 'CHANNEL_TOGGLE_SIDEBAR';
const CHANNEL_CLICKED_HELP = 'CHANNEL_CLICKED_HELP';
const CHANNEL_GLOBAL_HELP_BUTTON = 'CHANNEL_GLOBAL_HELP_BUTTON';
const CHANNEL_TOGGLE_HELP = 'CHANNEL_TOGGLE_HELP';
const WINDOW_SCROLL = 'WINDOW_SCROLL';
const CHANNEL_HEADER_MOVEMENT = 'CHANNEL_HEADER_MOVEMENT';
const CHANNEL_WAT_RECORD_UPDATED = 'CHANNEL_WAT_RECORD_UPDATED';
const CHANNEL_COACHMARK_UPDATE = 'CHANNEL_COACHMARK_UPDATE'; // to indicate we should update the coachmark placement

const MESSAGES = {
  ISAT_MODAL: 'isatmodal',
  ISAT_MODAL_HIDE: 'isatmodal_hide',
  MESSAGE_MODAL_HIDE: 'messagemodal_hide',
  MESSAGE_MODAL_SHOW: 'messagemodal_show',
  LOGGED_IN_MODAL_HIDE: 'loggedInmodal_hide',
  LOGOUT_MODAL_HIDE: 'logoutmodal_hide',
  SESSION_EXPIRED_MODAL_HIDE: 'sessionExpiredModal_hide',
  SESSION_EXPIRED_MODAL_SHOW: 'sessionExpiredModal_show',
};

const EventBus = new Vue();

export default {
  CHANNEL_AUTHENTICATED,
  CHANNEL_BUS_MESSAGE,
  CHANNEL_CLICKED_HELP,
  CHANNEL_COACHMARK_UPDATE,
  CHANNEL_ENVIRONMENT_LOADED,
  CHANNEL_GLOBAL_HELP_BUTTON,
  CHANNEL_HEADER_MOVEMENT,
  CHANNEL_TOC_LOADED,
  CHANNEL_TOGGLE_HELP,
  CHANNEL_TOGGLE_SIDEBAR,
  CHANNEL_USER_LOADED,
  CHANNEL_USER_AUTH_FAILED,
  CHANNEL_WAT_RECORD_UPDATED,
  MESSAGES,
  WINDOW_SCROLL,
  bus: EventBus
};